var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16092",
    "data-name": "Group 16092",
    transform: "translate(-175 -275)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6864",
    "data-name": "Rectangle 6864",
    width: 50,
    height: 50,
    transform: "translate(175 275)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7262",
    "data-name": "Group 7262",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7262",
    "data-name": "Path 7262",
    d: "M21.544,4.829a2.041,2.041,0,0,0-2.264,0L4.992,14.355a2.04,2.04,0,0,0-.622.654l14.91,9.94a2.041,2.041,0,0,0,2.264,0l14.91-9.94a2.04,2.04,0,0,0-.622-.654ZM40.814,15.7A6.124,6.124,0,0,0,38.1,10.958L23.809,1.432a6.124,6.124,0,0,0-6.794,0L2.727,10.958A6.124,6.124,0,0,0,.01,15.7,2.042,2.042,0,0,0,0,15.966q0,.044,0,.087V34.28A6.124,6.124,0,0,0,6.124,40.4H34.7a6.123,6.123,0,0,0,6.124-6.124V16.053q0-.044,0-.087A2.074,2.074,0,0,0,40.814,15.7Zm-4.073,4.019-8.057,5.371,8.057,5.371Zm-.229,15.5L25,27.548l-1.2.8a6.124,6.124,0,0,1-6.794,0l-1.2-.8L4.311,35.22a2.041,2.041,0,0,0,1.812,1.1H34.7A2.041,2.041,0,0,0,36.513,35.22ZM4.083,30.466l8.057-5.371L4.083,19.723Z",
    transform: "translate(180 279.596)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7262_-_Outline",
    "data-name": "Path 7262 - Outline",
    d: "M20.412.154a6.353,6.353,0,0,1,3.535,1.07L38.236,10.75a6.405,6.405,0,0,1,2.828,4.935,2.335,2.335,0,0,1,.01.282q0,.043,0,.086V34.28A6.381,6.381,0,0,1,34.7,40.654H6.124A6.381,6.381,0,0,1-.25,34.28V16.053q0-.043,0-.085a2.3,2.3,0,0,1,.01-.282A6.4,6.4,0,0,1,2.588,10.75L16.877,1.224A6.353,6.353,0,0,1,20.412.154Zm14.288,40a5.88,5.88,0,0,0,5.874-5.874V16.053q0-.042,0-.084v-.011a1.83,1.83,0,0,0-.008-.23v-.01a5.9,5.9,0,0,0-2.606-4.553L23.67,1.64a5.874,5.874,0,0,0-6.516,0L2.866,11.166A5.9,5.9,0,0,0,.26,15.719v.011a1.8,1.8,0,0,0-.008.229v.011q0,.042,0,.084V34.28a5.88,5.88,0,0,0,5.874,5.874ZM20.412,4.236a2.284,2.284,0,0,1,1.271.385l14.288,9.526a2.305,2.305,0,0,1,.7.734l.122.2L21.683,25.157a2.291,2.291,0,0,1-2.542,0L4.034,15.085l.122-.2a2.305,2.305,0,0,1,.7-.734L19.141,4.621A2.284,2.284,0,0,1,20.412,4.236ZM36.1,14.941a1.8,1.8,0,0,0-.411-.379L21.406,5.037a1.791,1.791,0,0,0-1.987,0L5.13,14.563a1.8,1.8,0,0,0-.411.379l14.7,9.8a1.791,1.791,0,0,0,1.987,0ZM3.833,19.256l8.758,5.839L3.833,30.933Zm7.856,5.839-7.356-4.9V30Zm25.3-5.838V30.933l-8.758-5.839ZM36.492,30V20.191l-7.356,4.9ZM15.82,27.248l1.335.89a5.874,5.874,0,0,0,6.516,0L25,27.248l11.833,7.889-.1.2A2.285,2.285,0,0,1,34.7,36.571H6.124A2.285,2.285,0,0,1,4.09,35.335l-.1-.2Zm4.593,2.376a6.353,6.353,0,0,1-3.535-1.07l-1.057-.7L4.648,35.3a1.786,1.786,0,0,0,1.476.775H34.7a1.786,1.786,0,0,0,1.476-.775L25,27.849l-1.057.7A6.353,6.353,0,0,1,20.412,29.624Z",
    transform: "translate(180 279.596)",
    fill: "#0b2e4d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationDark);
export default __webpack_public_path__ + "static/media/InvitationDark.e79ac29909348004b970f2a6ef0bce7a.svg";
export { ForwardRef as ReactComponent };